import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import {ifAuthenticated} from "@/routes/access";

import BlackLists from "@/pages/Pages/BlackLists/BlackLists.vue";
import BlackList from "@/pages/Pages/BlackLists/BlackList.vue";
import BlackListContacts from "@/pages/Pages/BlackLists/BlackListContacts.vue";
import BlackListContact from "@/pages/Pages/BlackLists/BlackListContact.vue";

let blackListMenu = {
  path: "/",
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  children: [
    {
      path: "/black_list/group",
      name: "black_list_group",
      component: BlackLists,
      meta: {
        icon: "security",
        msgKey: 'menu.item.contacts.black.lists'
      }
    },
    {
      path: "/black_list/group/new",
      name: "black_list_group_new",
      component: BlackList,
      meta: {
        parentPath: "/black_list/group",
        msgKey: 'menu.item.contacts.black.lists'
      }
    },
    {
      path: "/black_list/group/:id",
      name: "black_list_group_edit",
      component: BlackList,
      meta: {
        parentPath: "/black_list/group",
        msgKey: 'menu.item.contacts.black.lists'
      }
    },
    {
      path: "/black_list/group/:id/contact",
      name: "black_list_group_contact",
      component: BlackListContacts,
      meta: {
        parentPath: "/black_list/group",
        msgKey: 'menu.item.contacts.black.lists'
      }
    },
    {
      path: "/black_list/group/:id/contact/new",
      name: "black_list_group_contact_new",
      component: BlackListContact,
      meta: {
        showBack: true,
        msgKey: 'menu.item.contacts.black.lists'
      }
    },
    {
      path: "/black_list/group/:id/contact/:contactId",
      name: "black_list_group_contact_edit",
      component: BlackListContact,
      meta: {
        showBack: true,
        msgKey: 'menu.item.contacts.black.lists'
      }
    },
  ]
};

export default blackListMenu;